import Channel from '@shared/classes/channel';
import Focus from '@shared/types/enums/focus';
import TChannelList from '../templates/channelList';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { eventsSelector } from '../../../shared/store/slices/events.slice';
import { routerSelector } from '@shared/store/slices/router.slice';
import { stackFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useMemo } from 'react';

export default function Channels() {
  const dispatch = useAppDispatch();
  const { currentEvents } = useAppSelector(eventsSelector);
  const { favouriteChannels } = useAppSelector(channelsSelector);
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const currentIndex = useMemo(() => {
    return currentParams?.channel && favouriteChannels?.length
      ? Math.max(
          favouriteChannels?.findIndex(
            (item) => item.id === (currentParams.channel as Channel).id
          ),
          0
        )
      : 0;
  }, [currentParams, favouriteChannels]);

  useEffect(() => {
    dispatch(stackFocus(Focus.CHANNEL_LIST));
  }, []);

  return (
    <>
      {favouriteChannels?.length && (
        <TChannelList
          channelsData={favouriteChannels}
          currentChannel={favouriteChannels[currentIndex]}
          currentEvents={currentEvents}
          currentIndex={currentIndex}
          focusOnEnter={(currentParams?.stacked as boolean) ?? false}
        />
      )}
    </>
  );
}
